import React, { useState } from 'react';
import { FaHardHat, FaPlay, FaRoad } from 'react-icons/fa';
import ModalVideo from 'react-modal-video';
import '../../../node_modules/react-modal-video/scss/modal-video.scss';
import aboutImg from '../../assets/img/about_us.jpg';
import btnImg from '../../assets/img/Vedant-Tech-Logo-Transparent.png';
import IconBox from './IconBox';

function AboutFeatured() {
    const [isOpen, setOpen] = useState(false);
    return (
        <>
            <ModalVideo
                channel="youtube"
                autoplay
                isOpen={isOpen}
                videoId="EZ9DrY43wtw"
                onClose={() => setOpen(false)}
            />
            <section className="about-featured-wrapper section-padding">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-7 col-12 mt-5 mt-lg-0">
                            <div className="block-contents ml-lg-5">
                                <div className="section-title-3 mb-30">
                                    <p className="pl-50 pr-50">Message</p>
                                    <h1>Founder's Message</h1>
                                </div>
                                {/* <span>Message</span>
                                <h1>Founder’s Message</h1> */}
                                {/* <h4>
                                    Capitalise on low hanging fruit to identify a ballpark value
                                    added activity to beta test.
                                </h4> */}
                                <p>Our goal at Vedant Technology is to provide complete engineering and manufacturing solutions to our customers by combining technical knowledge, manufacturing experience, and a strong vendor network. We aim to support our customers from product development stage to mass production with a focus on quality, cost optimization, and reliable delivery.
                                </p>
                                <p>We believe in long-term business relationships, continuous improvement, and customer satisfaction through engineering excellence and manufacturing support.
                                </p>
                            </div>

                            {/* <div className="icon-boxs ml-lg-5">
                                <IconBox
                                    icon={<FaHardHat />}
                                    heading="Great Wall Support"
                                    text="Lorem ipsum dolor sit amet, consectetur adipisic ing elit, sed do eiusmod tempor incididunt"
                                />
                                <IconBox
                                    icon={<FaRoad />}
                                    heading="Creative Ideas"
                                    text="Lorem ipsum dolor sit amet, consectetur adipisic ing elit, sed do eiusmod tempor incididunt"
                                />
                            </div> */}
                        </div>
                        <div className="col-xl-6 col-lg-5 col-12 ">
                            <div
                                className="about-promo bg-cover"
                                style={{ backgroundImage: `url(${aboutImg})` }}
                            >
                                <div
                                    className="skill-popup-video d-flex justify-content-center align-items-center bg-contain"
                                    style={{ backgroundColor: "#ffffff" }}
                                >
                                    <img
                                        src={btnImg}
                                        alt=""
                                        style={{ width: "150px", height: '150px' }}
                                    />
                                    {/* <div className="video-play-btn">
                                        <button
                                            type="button"
                                            className="modal-btn"
                                            onClick={() => setOpen(true)}
                                        >
                                            <FaPlay />
                                        </button>
                                    </div> */}
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
        </>
    );
}

export default AboutFeatured;
